const defaultThemeData = {
	id: 1292,
	code: 'sharpr',
	name: 'Sharpr',
	appname: 'Sharpr',
	powered_by: '',
	tagline: 'Insight Platform',
	login_url: '',
	header: 'black',
	bubble: '#EE5834',
	link1: '#EE5834',
	link2: '#21A9C2',
	button1: '#EE5834',
	button2: '#0fa9c4',
	custom_css: `
.header-logo-image {
  margin-top: 8px;
}
.App header .logo {
  margin-top: 4px;
}
`,
	created_at: '2016-01-26T18:00:49+00:00',
	modified_at: '2017-02-23T19:58:10+00:00',
	on_light_url: window.BASE_URL + '/assets/theme/sharpr/on-light.png?v=iuxe',
	on_light_width: 137,
	on_light_height: 58,
	on_dark_url: window.BASE_URL + '/assets/theme/sharpr/on-dark.png?v=iuxe',
	on_dark_width: 136,
	on_dark_height: 71,
	missing_url: window.BASE_URL + '/assets/theme/sharpr/missing.png?v=iuxe',
	missing_width: 1000,
	missing_height: 750,
	v: 'iuxe',
};

export default defaultThemeData;
